import { Component, SkipSelf, ViewEncapsulation } from "@angular/core";
import { CommonFieldManagerDirective } from "../field-manager.directive";

@Component({
    selector: "common-field-hint",
    templateUrl: "./hint.component.html",
    encapsulation: ViewEncapsulation.None,
})
export class CommonFieldHintComponent {
    constructor( @SkipSelf() public fieldManager: CommonFieldManagerDirective) { }
}
